module.exports = __webpack_public_path__ + "static/media/crown-emoji.3f4fa693.png";